import styled from 'styled-components';

export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;

  @media screen and (max-width: 960px) {
    padding-top: 0;
    justify-content: initial;
  }
`;

export const Content = styled.div`
  width: 464px;
  height: 569px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  padding: 32px 32px 40px 32px;

  @media screen and (max-width: 960px) {
    margin-top: 20px;
    border-radius: 12px 12px 0 0;
    height: fit-content;
    width: 100%;
    z-index: 40;
    bottom: 0;
    position: absolute;
    padding: 20px 24px 0px 24px;
  }

  span {
    font-weight: 400;
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray};
  }

  .obs {
    font-size: 12px;
  }

  .default2 {
    margin: 0px 0px 24px 0px;
    display: flex;
    flex-direction: column;
    width: 100%;

    span {
      margin-bottom: 5px;
    }

    .color-black {
      color: ${(props) => props.theme.colors.black};
    }
  }

  .default {
    margin: 15px 0px 15px 0px;
    display: flex;
    flex-direction: column;
    width: 100%;
    .fileDiv {
      display: flex;
      flex-direction: row;
      align-content: center;
      margin-bottom: 10px;
      margin-top: 10px;

      .file {
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        font-size: 14px;
        align-self: center;
        border-style: solid;
        border-color: ${(props) => props.theme.colors.lightGray};
        color: ${(props) => props.theme.colors.black};
        border-width: 1px;
        width: 228px;
        height: 48px;
        padding: 15px;
        border-radius: 4px;
        @media screen and (max-width: 960px) {
          display: none;
        }
      }
    }
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;

  .close {
    width: 44px;
    display: none;
    color: ${(props) => props.theme.colors.primary};
    font-weight: 700;
    font-size: 14px;
  }

  .title {
    font-size: 24px;
    font-weight: 700;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    @media screen and (max-width: 960px) {
      justify-content: center;
    }
    color: ${(props) => props.theme.colors.primaryDark1};
  }

  .ghost {
  }

  @media screen and (max-width: 960px) {
    justify-content: center;

    .close {
      width: 44px;
      display: block;
      flex: 1;
      padding: 3px 0;
    }

    .title {
      flex: 3;
      font-size: 20px;
    }

    .ghost {
      width: 44px;
      height: 2px;
      background: ${(props) => props.theme.colors.white};
    }
  }
`;

export const Icon = styled.div`
  display: block;
  color: ${(props) => props.theme.colors.gray};
  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const Button = styled.button`
  background: ${(props) => props.theme.colors.primary};
  color: #fff;
  width: 100%;
  height: 60px;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  margin-top: 10px;
  margin-bottom: 25px;
  div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`;

export const TextArea = styled.textarea`
  margin-top: 5px;
  max-width: 400px;
  width: 100%;
  min-height: 120px;
  border-color: ${(props) => props.theme.colors.lightGray};
  padding: 15px;
  border-radius: 4px;
  font-size: 16px;
  font-family: ${(props) => props.theme.primaryFont};
  resize: none;

  @media screen and (max-width: 960px) {
    max-width: 320px;
    width: 100%;
    min-height: 120px;
  }
`;

export const FormDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
